import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React from 'react';

import InfoIcon from '@/assets/icons/info-icon.svg?react';

interface Props {
  readonly label: string | React.ReactElement;
  readonly help?: string;
  readonly value: string | React.ReactElement;
  readonly textVariant?: 'body2' | 'body1';
}

export const TransactionDetailsEntry: React.FC<Props> = (props: Props): React.ReactElement => {
  const { label, help, value, textVariant = 'body1' } = props;

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" height={24}>
      <Box display="flex" alignItems="center">
        {typeof label === 'string' ? (
          <Typography variant={textVariant} color="custom.LightGray">
            {label}
          </Typography>
        ) : (
          label
        )}
        {help && (
          <Tooltip title={help} placement="top">
            <Box width={24} height={24} mx={0.5}>
              <InfoIcon fontSize="small" />
            </Box>
          </Tooltip>
        )}
      </Box>

      {typeof value === 'string' ? <Typography variant={textVariant}>{value}</Typography> : value}
    </Box>
  );
};
